export default __webpack_public_path__ + "assets/cv/cv-bintang-mochamad-yussuf.34caa03d.pdf";